import * as React from "react";
import Container from '@mui/material/Container';
import {Box, Button, IconButton, Stack, Typography} from "@mui/material";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import {useState, useEffect} from "react";
import {ActualityCard} from "../index";
import CommunityCard from "../community/CommunityCard";
import {InstitutionCard} from "../index";
import Slider from "react-slick";
import {Article as ArticleIcon, Highlight as HighlightIcon,
    Soap as SoapIcon, Group as GroupIcon, Apartment as ApartmentIcon,
    QueryStats as QueryStatsIcon, Celebration as CelebrationIcon, RemoveRedEye as RemoveRedEyeIcon}
    from '@mui/icons-material';
import WysiwygCard from "../wysiwyg/WysiwygCard";
import EventDetailCardRender from "../event/EventDetailCardRender";
import {useDarkMode} from "../darkMode/hook/useDarkMode";
import ServiceItemPlaceholder from "../service/ServiceItemPlaceholder";
import ServiceItem from "../service/ServiceItem";
import ServiceItemUser from "../service/ServiceItemUser";



const ProductResult = ({
                    searchResponse, allowedResponse, setDisableSeeAll, setDisableEstablishment,
                           setDisableAdvice, setDisableService, setDisableProduct, setTabValue, isLoading
                }) => {
    const [showMoveUpButton, setShowMoveUpButton] = useState(false);
    const [showMoveDownButton, setShowMoveDownButton] = useState(true);
    const [anchor, setAnchor] = useState(0);
    const {mode} = useDarkMode();
    const [finalNbr, setFinalNbr] = useState(0);
    const [finalList, setFinalList] = useState(<div></div>);

    useEffect(() => {
        const res = renderResult(searchResponse);
        setFinalList(res[0]);
        setFinalNbr(res[1]);
    }, [searchResponse]);

    const renderResult = (list) => {
        const final = [];
        list.forEach((child) => {
            setDisableSeeAll(false);
            if (allowedResponse.indexOf(child.category) > -1) {
                switch(child.category) {
                    case 'service':
                        final.push(renderCardSlide(child));
                        setDisableService(false);
                        break;
                    case 'conseil':
                        final.push(renderCardSlide(child));
                        setDisableAdvice(false);
                        break;
                    case 'produit':
                        final.push(renderCardSlide(child));
                        setDisableProduct(false);
                        break;
                    default:
                }
            }
        })
        return ([final, final.length]);
    }

    const renderCardSlide = (product) => {
        console.log('products',product);
        return <Box>
            <ServiceItemUser
                id={product.id}
                title={product.name}
                description={product.description}
                variant={product.category}
                image={product.image}
                variantName={product.category}
                controls={['show-detail','marketplace', 'add-to-fav']}
                treading={false}
                treadingBadge={false}
                isFavorite={product.favorite}
                addMargin={true}
                wishlistId={product.wishlistId}
                wishListProductId={product.wishListIdProduct}
            />
        </Box>

    }

    const settingsServices = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: finalNbr <= 2 ? finalNbr : 2,
        arrows: true,
        responsive: [
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 1,
                    variableWidth : false,
                    arrows : true,
                    centerPadding: '0px',
                },
            },
            {
                breakpoint: 1300,
                settings: {
                    slidesToShow: 2,
                    variableWidth : false,
                    centerPadding: '0px',
                    arrows: true
                },
            }
        ],
        variableWidth : false,
        centerPadding: finalNbr <= 2 ? '0px' : '120px',
        centerMode: true,
    };

    const changeTab = (tabNumber) => {
        console.log('tabNumber',tabNumber)
        setTabValue(tabNumber);
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }

    const move = (direction, headerHeight) => {
        const tempPosition = anchor + direction;
        const tempAnchor = 'anchor'+tempPosition;
        const anchorEl = document.getElementById(tempAnchor);
        if (anchorEl) {
            window.scrollTo({
                top: anchorEl.offsetTop - headerHeight,
                behavior: "smooth",
            });
            setAnchor(anchor + direction);
        }
        const nextPosition = tempPosition + direction;
        if (document.getElementById('anchor'+nextPosition) == null && (direction < 0)) {
            setShowMoveDownButton(true);
            setShowMoveUpButton(false);
        } else if (document.getElementById('anchor'+nextPosition) == null) {
            setShowMoveDownButton(false);
            setShowMoveUpButton(true);
        } else {
            setShowMoveUpButton(true);
            setShowMoveDownButton(true);
        }
    };

    return (
        <div>
            {
                showMoveUpButton ?
                    <Box sx={{position: 'fixed', right: 0, top: '25%'}}>
                        <IconButton
                            className={'btn-gradient'}
                            sx={{
                                color: '#FFFFFF',
                                borderRadius: 0,
                                borderTopLeftRadius: '10%',
                                borderBottomLeftRadius: '10%'
                            }}
                            onClick={() => move(-1,process.env.REACT_APP_HEADER_HEIGHT)}
                        >
                            <ArrowUpwardIcon aria-label="Remonter au bloc précédent" role="img"/>
                        </IconButton>
                    </Box> : <div></div>
            }
            {
                showMoveDownButton ?
                    <Box sx={{position: 'fixed', right: 0, top: '32%'}}>
                        <IconButton
                            className={'btn-gradient'}
                            sx={{
                                color: '#FFFFFF',
                                borderRadius: 0,
                                borderTopLeftRadius: '10%',
                                borderBottomLeftRadius: '10%'
                            }}
                            onClick={() => move(1,process.env.REACT_APP_HEADER_HEIGHT)}
                        >
                            <ArrowDownwardIcon aria-label="Descendre au bloc suivant" role="img"/>
                        </IconButton>
                    </Box>: <div></div>
            }
            <Stack
                direction={'row'}
                flexWrap={'wrap'}
                justifyContent={{xs : "center", md : "center" , lg : "flex-start"}}
                gap={{xs : "50px", md : "53px" , lg : "67px"}}
                marginTop={'20px'}
            >
                {
                    finalList
                }
            </Stack>
            <br/>
        </div>
    )
}

export default ProductResult;
